module.exports = __webpack_public_path__ + "static/img/jkjc.fcb4534.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/img/jkjc.png
// module id = 2QRr
// module chunks = 1